document.addEventListener('DOMContentLoaded', () => {
	// This adds the 'required' class to it
	document.querySelectorAll('.wpcf7-validates-as-required').forEach(field => {
		const label = field.parentElement?.previousElementSibling;
		if (label) {
			label.classList.add('required');
		}
	});
});